@if (editor(); as editorModel) {
  <bd-value-editor
    dataIdPrefix="interactive-filter-chip"
    [descriptor]="editorModel"
    [valueLabel]="valueSegment()"
    [attributeCategoryDefinitions]="attributeCategoryDefinitions()"
    [disabled]="disabled()"
    [optionsLoading]="optionsLoading()"
    [objectSuggestions]="editContext()?.objectSuggestions ?? []"
    [objectSuggestionsLoading]="
      editContext()?.objectSuggestionsLoading ?? false
    "
    (selectNode)="onDropdownChange($event)"
    (attributeChange)="onAttributeValueChange($event)"
    (objectChange)="onRelationObjectChange($event)"
    (filterOptions)="onFilterOptions($event)"
    (searchObjects)="searchObjects.emit($event)"
  />
}
